import { toHeaderCase, toSnakeCase } from "js-convert-case";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useServiceStore } from "../store/service";

export default function useServiceState() {
  const service = useServiceStore();
  const { t } = useI18n();

  const currentState = computed(() => service.ctx.service?.currentState);
  const fsmState = computed(() => currentState.value?.fsmState);

  const stateLabel = computed(() => {
    const label = t(`ngp/fsm_states/${toSnakeCase(fsmState.value)}/label`);
    // Default if we don't have a translation for the state
    return label || toHeaderCase(fsmState.value);
  });

  const isRunning = computed(() => fsmState.value === "Running");
  const isFailed = computed(() => fsmState.value === "Failed");
  const canRestart = computed(() => isRunning.value || isFailed.value);
  const isSuspended = computed(() => fsmState.value === "Suspended");

  return { stateLabel, isRunning, isFailed, canRestart, isSuspended };
}
